import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ContractorModel from "../../viewModels/Contractors/ContractorModel";
import editContractorDrawerSlice from "../EditContractorDrawer/reducer";
import { CreateLeadFormInput } from ".";

const initialState: {
  open: boolean;
  loading: boolean;

  createdContractor?: ContractorModel;
} = {
  open: false,
  loading: false,
};

const createLeadModalSlice = createSlice({
  name: "createLeadModal",
  initialState,
  reducers: {
    openModal(state) {
      state.open = true;
    },
    closeModal(state) {
      state.open = false;
      state.createdContractor = undefined;
    },
    createLead(state, _action: PayloadAction<CreateLeadFormInput>) {
      state.loading = true;
    },
    createLeadSuccess(state) {
      state.open = false;
      state.loading = false;
      state.createdContractor = undefined;
    },
    createLeadReject(state) {
      state.loading = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(editContractorDrawerSlice.actions.createContractorSuccess, (state, action) => {
      if (state.open) {
        state.createdContractor = action.payload;
      }
    });
  },
});

export default createLeadModalSlice;
